import Login from '@/views/login/Login.vue'
import Register from '@/views/login/Register.vue'

export default [
    {
        // 登录页面
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        // 注册页面
        path: '/register',
        name: 'Register',
        component: Register
    }
]
